import { render, staticRenderFns } from "./PortraitCarouselModule.vue?vue&type=template&id=1b8196e6&"
import script from "./PortraitCarouselModule.ts?vue&type=script&lang=ts&"
export * from "./PortraitCarouselModule.ts?vue&type=script&lang=ts&"
import style0 from "./PortraitCarouselModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports